import {
  Directive,
  ElementRef,
  HostListener,
  OnDestroy,
  Renderer2
} from '@angular/core';

const FOCUS_CLASS = 'switch-has-focus';

// Rings the `.switch-label` beside a legacy `switch-input` checkbox while the checkbox has focus.
@Directive({
  selector: 'input[worSwitchFocus]'
})
export class SwitchFocusDirective implements OnDestroy {
  constructor (
    private elementRef : ElementRef<HTMLInputElement>,
    private renderer   : Renderer2
  ) {}

  private _setFocusClass ( hasFocus : boolean ) : void {
    const parent = this.elementRef.nativeElement.parentElement;

    if ( !parent ) {
      return;
    }

    parent.querySelectorAll('.switch-label').forEach(label => {
      if ( hasFocus ) {
        this.renderer.addClass(label, FOCUS_CLASS);
      }
      else {
        this.renderer.removeClass(label, FOCUS_CLASS);
      }
    });
  }

  ngOnDestroy () : void {
    this._setFocusClass(false);
  }

  @HostListener('blur')
  onBlur () : void {
    this._setFocusClass(false);
  }

  @HostListener('focus')
  onFocus () : void {
    this._setFocusClass(true);
  }
}
